import React from "react";
import { isMobile } from "react-device-detect";
import Unity, { UnityContext } from "react-unity-webgl";

const unityContext = new UnityContext({
    loaderUrl: "assets/purpose/purpose.loader.js",
    dataUrl: "assets/purpose/purpose.data",
    frameworkUrl: "assets/purpose/purpose.framework.js",
    codeUrl: "assets/purpose/purpose.wasm",
});

const fullscreenStyle = {
    position: "fixed",
    inset: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
    overflow: "hidden",
    backgroundColor: "black",
};

const unityStyle = {
    width: "100vw",
    height: "100vh",
    display: "block",
};

const Purpose = () => {
    if (isMobile) {
        return <div>This content is unavailable on mobile.</div>;
    }

    if (!detectWebGLContext()) {
        return <div>You need a browser that supports WebGL.</div>;
    }

    return (
        <div style={fullscreenStyle}>
            <Unity
                unityContext={unityContext}
                width="100vw"
                height="100vh"
                style={unityStyle}
            />
        </div>
    );
};

function detectWebGLContext() {
    const canvas = document.createElement("canvas");

    const gl =
        canvas.getContext("webgl") ||
        canvas.getContext("experimental-webgl");

    return !!gl;
}

export default Purpose;